import { Checkbox } from "src/components/MuiGenerals";
import { useBatchApproveAllowanceFormContext } from "../../../contexts";
import { enumChainIdToType } from "src/utils/constant";
import { useChains } from "src/components/FetchConfig";

function SmartAccountCheckbox() {
  const {
    fields: { isSmartAccount, chainName },
    setFields,
    translate: t,
  } = useBatchApproveAllowanceFormContext();

  const { selectChainByPieces } = useChains();

  const { chain_type } = selectChainByPieces({ chain_name: chainName });

  const isETH = enumChainIdToType.ETH === String(chain_type);
  const isTron = enumChainIdToType.TRON === String(chain_type);

  return (
    <>
      <span>{isTron ? t("auto_resource_rent") : t("smart_account")}</span>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}>
        <Checkbox
          checked={isSmartAccount}
          onChange={(e) =>
            setFields((f: any) => {
              const getMaxNumberOfAddresses = () => {
                if (e.target.checked && isETH) {
                  return "100";
                }

                return "1000";
              };

              return {
                ...f,
                isSmartAccount: e.target.checked,
                maxNumberOfAddresses: getMaxNumberOfAddresses(),
              };
            })
          }
        />
      </div>
    </>
  );
}

export default SmartAccountCheckbox;
